import { createContext } from 'react'

export interface ChartContextType {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Record<string, any>[]
  dataSets: Record<string, (number | null)[]>
  validDataSets: Record<string, number[]>
  activeIndex: number | null
  /** If not specified, it becomes responsive to the width of container element */
  plotAreaWidth?: number
  plotAreaHeight: number
  plotAreaPadding: {
    top?: number
    right?: number
    bottom?: number
    left?: number
  }
  xAxisHeight: number
  yAxisWidth: number
  ticks: number[]
  niceMin: number
  niceMax: number
  xScale: (index: number) => number
  yScale: (value: number) => number
}

export const LineChartContext = createContext<ChartContextType | null>(null)
